export default () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.604 5L6.604 9H2.604V15H6.604L11.604 19V5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.674 4.92969C21.5488 6.80496 22.6019 9.34805 22.6019 11.9997C22.6019 14.6513 21.5488 17.1944 19.674 19.0697M16.144 8.45969C17.0814 9.39733 17.608 10.6689 17.608 11.9947C17.608 13.3205 17.0814 14.592 16.144 15.5297"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
